import { z } from 'zod';
import { hotspotItemSchema } from './Hotspot.js';
export { HotspotIconPosition } from './Hotspot.js';
import { imageItemSchema } from './Image.js';
import { inputItemSchema } from './Input.js';
export { InputTypes } from './Input.js';
import { legacyCanvasDrawingItemSchema } from './LegacyCanvasDrawing.js';
import { legacyCanvasShapeItemSchema } from './LegacyCanvasShape.js';
import { lineItemSchema } from './Line.js';
import { shapeItemSchema } from './Shape.js';
export { ShapeTypes } from './Shape.js';
import { tableItemSchema } from './Table.js';
import { textItemSchema } from './Text.js';

const itemSchema = z.union([
  legacyCanvasShapeItemSchema,
  legacyCanvasDrawingItemSchema,
  hotspotItemSchema,
  textItemSchema,
  inputItemSchema,
  shapeItemSchema,
  imageItemSchema,
  tableItemSchema,
  lineItemSchema
]);
function isTextItem(item) {
  return item.kind === "text";
}
function isInputItem(item) {
  return item.kind === "input";
}
function isShapeItem(item) {
  return item.kind === "shape";
}
function isLegacyCanvasShapeItem(item) {
  return item.kind === "legacyCanvasShape";
}
function isLegacyCanvasDrawingItem(item) {
  return item.kind === "legacyCanvasDrawing";
}
function isImageItem(item) {
  return item.kind === "image";
}
function isTableItem(item) {
  return item.kind === "table";
}
function isLinkHotspotItem(item) {
  return item.kind === "linkHotspot";
}
function isSpeechSynthesisHotspotItem(item) {
  return item.kind === "speechHotspot";
}
function isHotspotItem(item) {
  return isLinkHotspotItem(item) || isSpeechSynthesisHotspotItem(item);
}
function isLineItem(item) {
  return item.kind === "line";
}

export { hotspotItemSchema, imageItemSchema, inputItemSchema, isHotspotItem, isImageItem, isInputItem, isLegacyCanvasDrawingItem, isLegacyCanvasShapeItem, isLineItem, isLinkHotspotItem, isShapeItem, isSpeechSynthesisHotspotItem, isTableItem, isTextItem, itemSchema, legacyCanvasDrawingItemSchema, legacyCanvasShapeItemSchema, lineItemSchema, shapeItemSchema, tableItemSchema, textItemSchema };
//# sourceMappingURL=index.js.map
